import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { CheckCircle2, Loader2, XCircle, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [status, setStatus] = useState("checking");
  const sessionId = params.get("session_id");

  useEffect(() => {
    let attempts = 0;
    const poll = async () => {
      if (!sessionId) { setStatus("error"); return; }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { await refreshUser(); setStatus("paid"); return; }
        if (data.status === "expired" || attempts > 12) { setStatus("error"); return; }
      } catch { if (attempts > 12) { setStatus("error"); return; } }
      attempts += 1;
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] px-6">
      <div className="max-w-md w-full text-center rounded-2xl border border-[#27334D] bg-[#111726] p-10 animate-fade-up">
        {status === "checking" && (<><Loader2 className="w-12 h-12 text-blue-400 animate-spin mx-auto mb-5" /><h1 className="font-display text-xl font-semibold mb-2">Confirming payment…</h1><p className="text-slate-400 text-sm">Hang tight, this only takes a moment.</p></>)}
        {status === "paid" && (<><CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto mb-5" /><h1 className="font-display text-2xl font-semibold mb-2">You're now Pro</h1><p className="text-slate-400 text-sm mb-6">Unlimited enrichment unlocked. Re-import to enrich your full network.</p><button onClick={() => navigate("/dashboard")} data-testid="payment-success-continue" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 px-6 py-3 rounded-lg font-medium text-sm transition-colors">Go to dashboard <ArrowRight className="w-4 h-4" /></button></>)}
        {status === "error" && (<><XCircle className="w-14 h-14 text-red-400 mx-auto mb-5" /><h1 className="font-display text-xl font-semibold mb-2">Payment not confirmed</h1><p className="text-slate-400 text-sm mb-6">If you were charged, it may take a minute. Otherwise try again.</p><button onClick={() => navigate("/billing")} className="inline-flex items-center gap-2 border border-[#27334D] hover:border-slate-500 px-6 py-3 rounded-lg font-medium text-sm transition-colors">Back to billing</button></>)}
      </div>
    </div>
  );
}
